import React from 'react'
import FieldsetItem from 'components/FieldsetItem'
import { Site, SiteNetSuiteAsset } from 'types'
import { DescriptionContainer, StyledLicenseItem } from './styles'

const buildLicenseDisplay = (license: SiteNetSuiteAsset): string => {
  return `${license.product ? license.product.description : license.id} 
    (${new Date(license.startDate).toLocaleDateString()} - 
     ${new Date(license.expirationDate).toLocaleDateString()})`
}

export interface MergeSiteDescriptionProps {
  site: Site
  siteUserCount: number
}

export const MergeSiteDescription: React.FC<MergeSiteDescriptionProps> = ({
  site,
  siteUserCount,
}) => (
  <DescriptionContainer>
    <FieldsetItem data={site.id} title="Site ID" />
    <FieldsetItem data={site.name} title="Name" />
    {site.netSuiteCustomer && (
      <FieldsetItem
        data={site.netSuiteCustomer.nsCustomerId}
        title="NSCustomer ID"
      />
    )}
    <FieldsetItem data={site.organization.name} title="Organization Name" />
    {site.organization.netSuiteCustomer && (
      <FieldsetItem
        data={site.organization.netSuiteCustomer.nsCustomerId}
        title="Organization NSCustomer ID"
      />
    )}
    <FieldsetItem data={siteUserCount} title="Site users Count" />
    <h5>Licenses:</h5>
    {site.netSuiteAssets && site.netSuiteAssets.length > 0
      ? site.netSuiteAssets.map(license => (
          <StyledLicenseItem key={`license-item-${license.id}`}>
            {buildLicenseDisplay(license)}
          </StyledLicenseItem>
        ))
      : 'No Licenses assigned'}
  </DescriptionContainer>
)

export default MergeSiteDescription
